import { Component, inject, OnInit } from "@angular/core";
import { ModalController, IonicModule } from "@ionic/angular";
import { GiftCategory, SpiritualGift } from "../services/spiritual-gifts/spiritual-gifts.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import rockQuestions from '../services/spiritual-gifts/assets/rock_questions.json';
import rockCategories from '../services/spiritual-gifts/assets/rock_categories.json';

import questions2024 from '../services/spiritual-gifts/assets/2024_questions.json';
import categories2024 from '../services/spiritual-gifts/assets/2024_categories.json';

import questions2022 from '../services/spiritual-gifts/assets/2022_questions.json';
import categories2022 from '../services/spiritual-gifts/assets/2022_categories.json';
import { SharedService } from "../services/rock/shared.service";

@Component({
    selector: 'app-questions',
    templateUrl: './questions.component.html',
    styleUrl: './questions.component.scss',
    standalone: true,
    imports: [IonicModule, FormsModule, ReactiveFormsModule]
})
export class QuestionsComponent implements OnInit {

  private modalCtrl = inject(ModalController);
  private sharedService = inject(SharedService);

  questions: {Id: string, Value: string, Category: {Id: number, Value: string}}[] = [];
  filteredQuestions: {Id: string, Value: string, Category: {Id: number, Value: string}}[] = [];
  categories: GiftCategory[] = [];
  testType: string = 'rock_default';
  inputData = '';

  constructor() {}

  closeModal() {
    this.modalCtrl.dismiss();
  }

  ngOnInit(): void {
      this.changeTest();
  }

  changeTest() {

    this.questions = [];

    let questions: any;
    let categories: any;

    switch (this.testType) {
      case 'lbc_2024':
        questions = questions2024;
        categories = categories2024;
        break;
      case 'lbc_2022':
        questions = questions2022;
        categories = categories2022;
        break;
      case 'rock_default':
      default:
        questions = rockQuestions;
        categories = rockCategories;
        break;
    }

    this.categories = categories.filter((category: GiftCategory) => category.Constructs.length > 0);

    Object.values(questions).map(question => {
      Object.keys(question).map(key => {
        const category = this.categories.find(c => c.Constructs.includes(key));
        const q = {Id: key, Value: question[key], Category: {Id: category.Id, Value: category.Value}};
        this.questions.push(q);
      });
    });

    this.categories.map(category => {
      category.Questions = this.questions.filter(q => category.Constructs.includes(q.Id));
    });

    this.categories.sort((a, b) => a.Value.localeCompare(b.Value));
    this.questions.sort((a, b) => a.Category.Value.localeCompare(b.Category.Value));

    this.filteredQuestions = this.sharedService.deepCopy(this.questions);

  }

  filterNames() {
    this.questions = this.filteredQuestions.filter(name => {
      if (name.Value.toLowerCase().indexOf(this.inputData.toLowerCase()) > -1) {
        return name;
      } 
    });
  }

}